;(() => {
  if (customElements.get('products-module')) {
    return
  }

  class ProductsModule extends HTMLElement {
    constructor() {
      super()

      this.sliderConfig = {
        type: 'loop',
        arrows: true,
        pagination: false,
        perPage: 1,
        waitForTransition: false,
        gap: '3rem',
        focus: 'center',
        breakpoints: {
          990: {
            fixedWidth: '100%',
            gap: '3rem',
          },
        },
      }
      this.initSliderHandler = this.initSlider.bind(this)
    }

    connectedCallback() {
      this.initSliderHandler()
    }

    initSlider() {
      const slider = this.querySelector('.splide')

      if (!slider) {
        return
      }

      this.sliderInstance = new Splide(slider, this.sliderConfig).mount()

      return this.sliderInstance
    }
  }

  customElements.define('products-module', ProductsModule)
})()
